/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  pendingProductAllocationsList,
  pendingProductAllocationDocumentsList,
  pendingProductAllocationDocumentIds,
} from '../../../app/store/actions/outboundOrderAllocations';
import { allocateBulkProducts } from '../../../app/store/actions/outboundPendingAllocationMonitor';
import { getPageLayout, updatePageLayout } from '../../../app/store/actions/pageLayout';
import Permissions from '../../../app/services/permissions';
import addNotification from '../../../components/notification';
import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import FormatHelpers from '../../../helpers/format';
import OneClickButton from '../../../components/form/button';
import Form from '../../../components/form/form';

class PendingAllocationProductList extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE41' /* Expedição */) },
      { value: I18n.t('BEE3316' /* Produtos Pendentes para Alocação */), active: true },
    ];

    // Estado da grid de documentos enviado ao servidor a cada consulta: a tela
    // deixou de trazer todos os produtos pendentes do periodo e paginar em
    // memoria.
    this.page = 0;
    this.pageSize = 5;
    this.sorted = [];
    this.filtered = [];

    this.state = {
      productsList: [],
      documentsList: [],
      selectedDocument: {},
      selectedAllocations: {},
      selectedIds: [],
      pages: 0,
      totalDataLength: 0,
      loading: false,
      defaultPageSize: 10,
      defaultSorted: [{ id: 'productCode', desc: false }],
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      showModalPendingAllocation: false,
      showModalPageLayout: false,
      pageLayout: {
        showOrderType: true,
        showLoadNumber: true,
        showLineNumber: true,
        showProductCode: true,
        showProductFullName: true,
        showQuantity: true,
        showAvailable: true,
        showCustomerCode: true,
        showCustomerName: true,
        showCustomerOrderCode: true,
        showCreatedAt: true,
        showDeliveryDate: true,
        showProductProductCode: true,
        showProductProductName: true,
        showProductCustomerOrderCode: true,
        showProductOrderNumber: true,
        showProductUnitMeasure: true,
        showProductQuantity: true,
        showProductAvailable: true,
        showProductDepositCode: true,
        showProductAddressCode: true,
        showProductLotNumber: true,
        showProductStockQuantity: true,
        showProductAllocated: true,
        showProductBranchCode: true,
        showProductLoadNumber: true,
        showProductTotalValue: true,
        showProductOrderValue: true,
        showProductOrderType: true,
        showProductCustomerCode: true,
        showProductCustomerName: true,
        showProductLineNumber: true,
        showProductMandatoryQuantity: true,
        showProductCreatedAt: true,
        showProductExpirationDate: true,
        showProductDeliveryDate: true,
      },
      tableColumns: [],
      productTableColumns: [],
      showOrderType: true,
      showLoadNumber: true,
      showLineNumber: true,
      showProductCode: true,
      showProductFullName: true,
      showQuantity: true,
      showAvailable: true,
      showCustomerCode: true,
      showCustomerName: true,
      showCustomerOrderCode: true,
      showCreatedAt: true,
      showDeliveryDate: true,
      showProductProductCode: true,
      showProductProductName: true,
      showProductCustomerOrderCode: true,
      showProductOrderNumber: true,
      showProductUnitMeasure: true,
      showProductQuantity: true,
      showProductAvailable: true,
      showProductDepositCode: true,
      showProductAddressCode: true,
      showProductLotNumber: true,
      showProductStockQuantity: true,
      showProductAllocated: true,
      showProductBranchCode: true,
      showProductLoadNumber: true,
      showProductTotalValue: true,
      showProductOrderValue: true,
      showProductOrderType: true,
      showProductCustomerCode: true,
      showProductCustomerName: true,
      showProductLineNumber: true,
      showProductMandatoryQuantity: true,
      showProductCreatedAt: true,
      showProductExpirationDate: true,
      showProductDeliveryDate: true,
    };
  }

  async componentDidMount() {
    // A primeira carga da grid vem do onFetchData (paginacao no servidor):
    // chamar aqui tambem faria duas consultas ao abrir a tela.
    await this.getPageLayout();
    this.updateColumns();
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.userLogged && this.props.userLogged) {
      await this.getPageLayout();
      this.updateColumns();
    }
  }

  singleSelection = (idAllocation) => {
    this.setState((prevState) => {
      const { selectedAllocations } = prevState;
      return {
        selectedAllocations: {
          ...selectedAllocations,
          [idAllocation]: !selectedAllocations[idAllocation],
        },
      };
    });
  };

  multipleSelection = async (selectionOption) => {
    if (!selectionOption) {
      this.setState({ selectedAllocations: {}, selectedIds: [] });
      return;
    }

    // A grid so tem a pagina atual: os produtos que o filtro alcanca - e que o
    // tipo de pedido deixa marcar - vem do servidor, para o botao continuar
    // marcando a base inteira e nao so a pagina exibida.
    const result = await this.props.pendingProductAllocationDocumentIds(this.buildTableParams());
    const ids = (result && result.ids) || [];

    const updatedSelectedAllocations = {};
    for (const id of ids) {
      updatedSelectedAllocations[id] = true;
    }

    this.setState((prevState) => ({
      selectedAllocations: { ...prevState.selectedAllocations, ...updatedSelectedAllocations },
    }));
  };

  validChecked = () => {
    const { selectedAllocations } = this.state;
    if (!Object.keys(selectedAllocations).length) {
      addNotification(
        'danger',
        I18n.t('BEE2223' /* Monitor de Integração */),
        I18n.t('BEE2236' /* Nenhuma integração selecionada */),
        'top-right',
      );
    } else {
      const selectedIds = [];
      for (const index in selectedAllocations) {
        if (selectedAllocations[index]) selectedIds.push(index);
      }
      if (selectedIds.length) {
        this.setState({
          selectedIds: [...selectedIds],
          showModalPendingAllocation: true,
        });
      } else {
        addNotification(
          'danger',
          I18n.t('BEE2223' /* Monitor de Integração */),
          I18n.t('BEE2236' /* Nenhuma integração selecionada */),
          'top-right',
        );
      }
    }
  };

  updateColumns = () => {
    const newTableColumns = this.getTableColumns();
    const newProductTableColumns = this.getProductTableColumns();
    this.setState({
      tableColumns: newTableColumns,
      productTableColumns: newProductTableColumns,
    });
  };

  getPageLayout = async () => {
    const { userLogged } = this.props;

    if (userLogged && userLogged.mainBranchData) {
      const { mainBranchData } = userLogged;

      const layoutSelected = await this.props.getPageLayout({
        branchCode: mainBranchData.code,
        page: this.props.location.pathname,
      });

      if (layoutSelected && layoutSelected.layout) {
        this.setState({
          pageLayout: {
            ...layoutSelected.layout,
          },
          showOrderType: layoutSelected.layout.showOrderType,
          showLoadNumber: layoutSelected.layout.showLoadNumber,
          showLineNumber: layoutSelected.layout.showLineNumber,
          showProductCode: layoutSelected.layout.showProductCode,
          showProductFullName: layoutSelected.layout.showProductFullName,
          showQuantity: layoutSelected.layout.showQuantity,
          showAvailable: layoutSelected.layout.showAvailable,
          showCustomerCode: layoutSelected.layout.showCustomerCode,
          showCustomerName: layoutSelected.layout.showCustomerName,
          showCustomerOrderCode: layoutSelected.layout.showCustomerOrderCode,
          showCreatedAt: layoutSelected.layout.showCreatedAt,
          showDeliveryDate: layoutSelected.layout.showDeliveryDate,
          showProductProductCode: layoutSelected.layout.showProductProductCode,
          showProductProductName: layoutSelected.layout.showProductProductName,
          showProductCustomerOrderCode: layoutSelected.layout.showProductCustomerOrderCode,
          showProductOrderNumber: layoutSelected.layout.showProductOrderNumber,
          showProductUnitMeasure: layoutSelected.layout.showProductUnitMeasure,
          showProductQuantity: layoutSelected.layout.showProductQuantity,
          showProductAvailable: layoutSelected.layout.showProductAvailable,
          showProductDepositCode: layoutSelected.layout.showProductDepositCode,
          showProductAddressCode: layoutSelected.layout.showProductAddressCode,
          showProductLotNumber: layoutSelected.layout.showProductLotNumber,
          showProductStockQuantity: layoutSelected.layout.showProductStockQuantity,
          showProductAllocated: layoutSelected.layout.showProductAllocated,
          showProductBranchCode: layoutSelected.layout.showProductBranchCode,
          showProductLoadNumber: layoutSelected.layout.showProductLoadNumber,
          showProductTotalValue: layoutSelected.layout.showProductTotalValue,
          showProductOrderValue: layoutSelected.layout.showProductOrderValue,
          showProductOrderType: layoutSelected.layout.showProductOrderType,
          showProductCustomerCode: layoutSelected.layout.showProductCustomerCode,
          showProductCustomerName: layoutSelected.layout.showProductCustomerName,
          showProductLineNumber: layoutSelected.layout.showProductLineNumber,
          showProductMandatoryQuantity: layoutSelected.layout.showProductMandatoryQuantity,
          showProductCreatedAt: layoutSelected.layout.showProductCreatedAt,
          showProductExpirationDate: layoutSelected.layout.showProductExpirationDate,
          showProductDeliveryDate: layoutSelected.layout.showProductDeliveryDate,
        });
      }
    }
  };

  updatePageLayoutArray = () => {
    const {
      showOrderType, showLoadNumber, showLineNumber, showProductCode, showProductFullName,
      showQuantity, showAvailable, showCustomerCode, showCustomerName, showCustomerOrderCode,
      showCreatedAt, showDeliveryDate, showProductProductCode, showProductProductName, showProductCustomerOrderCode,
      showProductOrderNumber, showProductUnitMeasure, showProductQuantity, showProductAvailable, showProductDepositCode,
      showProductAddressCode, showProductLotNumber, showProductStockQuantity, showProductAllocated,
      showProductBranchCode, showProductLoadNumber, showProductTotalValue, showProductOrderValue, showProductOrderType,
      showProductCustomerCode, showProductCustomerName, showProductLineNumber, showProductMandatoryQuantity,
      showProductCreatedAt, showProductExpirationDate, showProductDeliveryDate,
    } = this.state;

    const layout = {
      showOrderType,
      showLoadNumber,
      showLineNumber,
      showProductCode,
      showProductFullName,
      showQuantity,
      showAvailable,
      showCustomerCode,
      showCustomerName,
      showCustomerOrderCode,
      showCreatedAt,
      showDeliveryDate,
      showProductProductCode,
      showProductProductName,
      showProductCustomerOrderCode,
      showProductOrderNumber,
      showProductUnitMeasure,
      showProductQuantity,
      showProductAvailable,
      showProductDepositCode,
      showProductAddressCode,
      showProductLotNumber,
      showProductStockQuantity,
      showProductAllocated,
      showProductBranchCode,
      showProductLoadNumber,
      showProductTotalValue,
      showProductOrderValue,
      showProductOrderType,
      showProductCustomerCode,
      showProductCustomerName,
      showProductLineNumber,
      showProductMandatoryQuantity,
      showProductCreatedAt,
      showProductExpirationDate,
      showProductDeliveryDate,
    };

    try {
      const { userLogged } = this.props;

      if (userLogged && userLogged.mainBranchData) {
        const { mainBranchData } = userLogged;

        const updLayout = this.props.updatePageLayout({
          branchCode: mainBranchData.code,
          page: this.props.location.pathname,
          layout,
        });

        if (updLayout) {
          addNotification(
            'success',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4442' /* Atualização do Layout de Página efetuada com sucesso! */),
            'top-right',
          );

          this.setState({
            pageLayout: layout,
          });
          this.updateColumns();
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            `${error.code} - ${error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
      }
    }
    this.setState({
      showModalPageLayout: false,
    });
  };

  resetLayout = () => {
    this.setState({
      showOrderType: true,
      showLoadNumber: true,
      showLineNumber: true,
      showProductCode: true,
      showProductFullName: true,
      showQuantity: true,
      showAvailable: true,
      showCustomerCode: true,
      showCustomerName: true,
      showCustomerOrderCode: true,
      showCreatedAt: true,
      showDeliveryDate: true,
      showProductProductCode: true,
      showProductProductName: true,
      showProductCustomerOrderCode: true,
      showProductOrderNumber: true,
      showProductUnitMeasure: true,
      showProductQuantity: true,
      showProductAvailable: true,
      showProductDepositCode: true,
      showProductAddressCode: true,
      showProductLotNumber: true,
      showProductStockQuantity: true,
      showProductAllocated: true,
      showProductBranchCode: true,
      showProductLoadNumber: true,
      showProductTotalValue: true,
      showProductOrderValue: true,
      showProductOrderType: true,
      showProductCustomerCode: true,
      showProductCustomerName: true,
      showProductLineNumber: true,
      showProductMandatoryQuantity: true,
      showProductCreatedAt: true,
      showProductExpirationDate: true,
      showProductDeliveryDate: true,
    });
  };

  showPageLayoutModal = () => {
    this.setState({
      showModalPageLayout: true,
    });
  };

  closePageLayoutModal = () => {
    this.getPageLayout();
    this.setState({
      showModalPageLayout: false,
    });
  };

  showColumn = (layout, fieldName) => {
    if (layout) {
      return layout[fieldName] || false;
    }
    return true;
  };

  getTableColumns = () => {
    const { pageLayout = {} } = this.state;

    return [
      {
        Header: I18n.t('BEE436' /* Selecionar */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (row) => {
          const allowCheck = row.original && row.original.outboundOrder
            && row.original.outboundOrder.typeOrders
            ? row.original.outboundOrder.typeOrders.productionSeparation
            && row.original.outboundOrder.typeOrders.separateProductIntegration
            : false;
          return (
            <div style={{ textAlign: 'center' }}>
              {(row.original.status !== 200) && (
                <input
                  type="checkbox"
                  disabled={!allowCheck}
                  checked={this.state.selectedAllocations[row.original.id] || false}
                  onChange={() => this.singleSelection(row.original.id)}
                />
              )}
            </div>
          );
        },
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: true,
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE443' /* Documento */),
        accessor: 'outboundOrder.orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: true,
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'outboundOrder.orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showOrderType'),
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4526' /* Carga */),
        accessor: 'outboundOrder.load.loadNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showLoadNumber'),
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showLineNumber'),
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE378' /* Código do Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductCode'),
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2170' /* Descrição Produto */),
        accessor: 'product.fullName',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductFullName'),
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showQuantity'),
        minWidth: 150,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE530' /* Disponível */),
        accessor: 'balances.totalAvailable',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showAvailable'),
        minWidth: 150,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
        // E a soma dos saldos do produto, calculada pelo servidor depois do
        // agrupamento: da para ordenar, mas nao ha coluna para filtrar.
        filterable: false,
      }, {
        Header: I18n.t('BEE50' /* Cliente */),
        accessor: 'outboundOrder.customerCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showCustomerCode'),
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE84' /* Razão Social */),
        accessor: 'outboundOrder.customer.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showCustomerName'),
        minWidth: 400,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1808' /* Pedido Cliente */),
        accessor: 'outboundOrder.customerOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showCustomerOrderCode'),
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2224' /* Data Integração */),
        accessor: 'createdAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showCreatedAt'),
        minWidth: 140,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (
            _.includes(dateFirstOption, input)
            || _.includes(dateSecondOption, input)
          ) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {moment(row.value).format('L LTS')}
          </span>
        ),
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'outboundOrder.deliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showDeliveryDate'),
        minWidth: 130,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {moment(row.value).format('L')}
          </span>
        ),
      },
    ];
  };

  getProductTableColumns = () => {
    const { pageLayout = {} } = this.state;

    return [
      {
        Header: I18n.t('BEE378' /* Código do Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductProductCode'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE2170' /* Descrição Produto */),
        accessor: 'product.fullName',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductProductName'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE1096' /* Pedido Cliente */),
        accessor: 'outboundOrder.customerOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductCustomerOrderCode'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE443' /* Documento */),
        accessor: 'outboundOrder.orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductOrderNumber'),
        minWidth: 150,
      },
      {
        Header: I18n.t('BEE1756' /* Unidade de Medida */),
        accessor: 'product.unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductUnitMeasure'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE2171' /* Quantidade Pedido */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductQuantity'),
        minWidth: 150,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE530' /* Disponível */),
        accessor: 'balances.available',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductAvailable'),
        minWidth: 150,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE182' /* Depósito */),
        accessor: 'balances.depositCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductDepositCode'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE267' /* Endereço */),
        accessor: 'balances.addressCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductAddressCode'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE428' /* Lote */),
        accessor: 'balances.lotNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductLotNumber'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE2241' /* Quantidade Estoque */),
        accessor: 'balances.quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductStockQuantity'),
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE2008' /* Quantidade Alocada */),
        accessor: 'balances.allocated',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductAllocated'),
        minWidth: 200,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductBranchCode'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE4526' /* Carga */),
        accessor: 'outboundOrder.load.loadNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductLoadNumber'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE1687' /* Valor Total */),
        accessor: 'outboundOrder.totalValue',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductTotalValue'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE3921' /* Total da Mercadoria */),
        accessor: 'outboundOrder.orderValue',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductOrderValue'),
        minWidth: 200,
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'outboundOrder.orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductOrderType'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE381' /* Código do Cliente */),
        accessor: 'outboundOrder.customerCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductCustomerCode'),
        minWidth: 250,
      }, {
        Header: I18n.t('BEE84' /* Razão Social */),
        accessor: 'outboundOrder.customer.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductCustomerName'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductLineNumber'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE1579' /* Lance Obrigatório */),
        accessor: 'mandatoryQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductMandatoryQuantity'),
        minWidth: 150,
      }, {
        Header: I18n.t('BEE2224' /* Data Integração */),
        accessor: 'createdAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductCreatedAt'),
        minWidth: 150,
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE2398' /* Data de Validade */),
        accessor: 'balances.expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductExpirationDate'),
        minWidth: 150,
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'outboundOrder.deliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        show: this.showColumn(pageLayout, 'showProductDeliveryDate'),
        minWidth: 150,
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      },
    ];
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  createPageLayoutModal = () => {
    const {
      showModalPageLayout, showOrderType, showLoadNumber, showLineNumber, showProductCode, showProductFullName,
      showQuantity, showAvailable, showCustomerCode, showCustomerName, showCustomerOrderCode,
      showCreatedAt, showDeliveryDate, showProductProductCode, showProductProductName, showProductCustomerOrderCode,
      showProductOrderNumber, showProductUnitMeasure, showProductQuantity, showProductAvailable, showProductDepositCode,
      showProductAddressCode, showProductLotNumber, showProductStockQuantity, showProductAllocated,
      showProductBranchCode, showProductLoadNumber, showProductTotalValue, showProductOrderValue, showProductOrderType,
      showProductCustomerCode, showProductCustomerName, showProductLineNumber, showProductMandatoryQuantity,
      showProductCreatedAt, showProductExpirationDate, showProductDeliveryDate,
    } = this.state;

    return (
      <Modal
        size="md"
        isOpen={showModalPageLayout}
        toggle={() => this.closePageLayoutModal()}
      >
        <ModalHeader toggle={() => this.closePageLayoutModal()}>
          <span className="text-center">
            {I18n.t('BEE4439' /* Gerenciar Colunas */).toLocaleUpperCase()}
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12 text-right">
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE1378' /* Documento */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showOrderType,
                    'showOrderType',
                    I18n.t('BEE200' /* Tipo */),
                  ),
                  formContext.createToggleBox(
                    showLoadNumber,
                    'showLoadNumber',
                    I18n.t('BEE4526' /* Carga */),
                  ),
                  formContext.createToggleBox(
                    showLineNumber,
                    'showLineNumber',
                    I18n.t('BEE463' /* Linha */),
                  ),
                  formContext.createToggleBox(
                    showProductCode,
                    'showProductCode',
                    I18n.t('BEE378' /* Código do Produto */),
                  ),
                  formContext.createToggleBox(
                    showProductFullName,
                    'showProductFullName',
                    I18n.t('BEE2170' /* Descrição Produto */),
                  ),
                  formContext.createToggleBox(
                    showQuantity,
                    'showQuantity',
                    I18n.t('BEE441' /* Quantidade */),
                  ),
                  formContext.createToggleBox(
                    showAvailable,
                    'showAvailable',
                    I18n.t('BEE530' /* Disponível */),
                  ),
                  formContext.createToggleBox(
                    showCustomerCode,
                    'showCustomerCode',
                    I18n.t('BEE50' /* Cliente */),
                  ),
                  formContext.createToggleBox(
                    showCustomerName,
                    'showCustomerName',
                    I18n.t('BEE84' /* Razão Social */),
                  ),
                  formContext.createToggleBox(
                    showCustomerOrderCode,
                    'showCustomerOrderCode',
                    I18n.t('BEE1096' /* Pedido cliente */),
                  ),
                  formContext.createToggleBox(
                    showCreatedAt,
                    'showCreatedAt',
                    I18n.t('BEE2224' /* Data Integração */),
                  ),
                  formContext.createToggleBox(
                    showDeliveryDate,
                    'showDeliveryDate',
                    I18n.t('BEE444' /* Data de Entrega */),
                  ),
                ])}
              />
            </div>
            <hr />
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE27' /* Produtos */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showProductProductCode,
                    'showProductProductCode',
                    I18n.t('BEE378' /* Código do Produto */),
                  ),
                  formContext.createToggleBox(
                    showProductProductName,
                    'showProductProductName',
                    I18n.t('BEE2170' /* Descrição Produto */),
                  ),
                  formContext.createToggleBox(
                    showProductCustomerOrderCode,
                    'showProductCustomerOrderCode',
                    I18n.t('BEE1096' /* Pedido Cliente */),
                  ),
                  formContext.createToggleBox(
                    showProductOrderNumber,
                    'showProductOrderNumber',
                    I18n.t('BEE443' /* Documento */),
                  ),
                  formContext.createToggleBox(
                    showProductUnitMeasure,
                    'showProductUnitMeasure',
                    I18n.t('BEE1756' /* Unidade de Medida */),
                  ),
                  formContext.createToggleBox(
                    showProductQuantity,
                    'showProductQuantity',
                    I18n.t('BEE2171' /* Quantidade Pedido */),
                  ),
                  formContext.createToggleBox(
                    showProductAvailable,
                    'showProductAvailable',
                    I18n.t('BEE530' /* Disponível */),
                  ),
                  formContext.createToggleBox(
                    showProductDepositCode,
                    'showProductDepositCode',
                    I18n.t('BEE182' /* Depósito */),
                  ),
                  formContext.createToggleBox(
                    showProductAddressCode,
                    'showProductAddressCode',
                    I18n.t('BEE267' /* Endereço */),
                  ),
                  formContext.createToggleBox(
                    showProductLotNumber,
                    'showProductLotNumber',
                    I18n.t('BEE428' /* Lote */),
                  ),
                  formContext.createToggleBox(
                    showProductStockQuantity,
                    'showProductStockQuantity',
                    I18n.t('BEE2241' /* Quantidade Estoque */),
                  ),
                  formContext.createToggleBox(
                    showProductAllocated,
                    'showProductAllocated',
                    I18n.t('BEE2008' /* Quantidade Alocada */),
                  ),
                  formContext.createToggleBox(
                    showProductBranchCode,
                    'showProductBranchCode',
                    I18n.t('BEE145' /* Filial */),
                  ),
                  formContext.createToggleBox(
                    showProductLoadNumber,
                    'showProductLoadNumber',
                    I18n.t('BEE4526' /* Carga */),
                  ),
                  formContext.createToggleBox(
                    showProductTotalValue,
                    'showProductTotalValue',
                    I18n.t('BEE1687' /* Valor Total */),
                  ),
                  formContext.createToggleBox(
                    showProductOrderValue,
                    'showProductOrderValue',
                    I18n.t('BEE3921' /* Total da Mercadoria */),
                  ),
                  formContext.createToggleBox(
                    showProductOrderType,
                    'showProductOrderType',
                    I18n.t('BEE200' /* Tipo */),
                  ),
                  formContext.createToggleBox(
                    showProductCustomerCode,
                    'showProductCustomerCode',
                    I18n.t('BEE381' /* Código do Cliente */),
                  ),
                  formContext.createToggleBox(
                    showProductCustomerName,
                    'showProductCustomerName',
                    I18n.t('BEE84' /* Razão Social */),
                  ),
                  formContext.createToggleBox(
                    showProductLineNumber,
                    'showProductLineNumber',
                    I18n.t('BEE463' /* Linha */),
                  ),
                  formContext.createToggleBox(
                    showProductMandatoryQuantity,
                    'showProductMandatoryQuantity',
                    I18n.t('BEE1579' /* Lance Obrigatório */),
                  ),
                  formContext.createToggleBox(
                    showProductCreatedAt,
                    'showProductCreatedAt',
                    I18n.t('BEE2224' /* Data Integração */),
                  ),
                  formContext.createToggleBox(
                    showProductExpirationDate,
                    'showProductExpirationDate',
                    I18n.t('BEE2398' /* Data de Validade */),
                  ),
                  formContext.createToggleBox(
                    showProductDeliveryDate,
                    'showProductDeliveryDate',
                    I18n.t('BEE444' /* Data de Entrega */),
                  ),
                ])}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={this.resetLayout}
            >
              {I18n.t('BEE4443' /* Restaurar padrão */)}
            </button>
            <div>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-white p-5 m-5"
                onClick={this.closePageLayoutModal}
              >
                {I18n.t('BEE99' /* Cancelar */)}
              </OneClickButton>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={this.updatePageLayoutArray}
              >
                {I18n.t('BEE139' /* Atualizar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  };

  handleDateApplyEvent = async (event) => {
    await this.setState({
      startDate: event[0],
      endDate: event[1],
    });

    // Trocar o periodo com a grid numa pagina do meio pediria ao servidor uma
    // pagina que o novo periodo pode nem ter: volta para a primeira. Mudar a
    // pagina por fora nao faz a grid buscar de novo (ela so avisa o onFetchData
    // quando quem paginou foi o usuario), entao a consulta e feita aqui.
    this.page = 0;

    if (this.tableComponent) {
      this.tableComponent.handlePageChange(0);
    }

    this.pendingProductAllocationDocumentsList();
  };

  buildTableParams = () => ({
    filterStartDate: moment(this.state.startDate).format(),
    filterEndDate: moment(this.state.endDate).format(),
    page: this.page,
    pageSize: this.pageSize,
    sorted: this.sorted,
    filtered: this.filtered,
  });

  pendingProductAllocationDocumentsList = async () => {
    this.setState({ loading: true });

    try {
      const documentsList = await this.props.pendingProductAllocationDocumentsList(this.buildTableParams());

      if (documentsList && documentsList.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      } else {
        this.setState({
          documentsList: (documentsList && documentsList.rows) || [],
          pages: (documentsList && documentsList.pages) || 0,
          totalDataLength: (documentsList && documentsList.totalDataLength) || 0,
        });
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE3316' /* Produtos Pendentes para Alocação */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  pendingProductAllocationsList = async () => {
    const { selectedDocument } = this.state;
    try {
      const productsList = await this.props.pendingProductAllocationsList(
        selectedDocument.outboundOrderId,
        selectedDocument.productCode,
      );

      if (productsList && productsList.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      } else {
        this.setState({
          productsList,
        });
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE3316' /* Produtos Pendentes para Alocação */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  allocateBulkProduct = async (outboundProductIds) => {
    try {
      this.setState({
        showModalPendingAllocation: false,
      });
      const result = await this.props.allocateBulkProducts(outboundProductIds);

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          'Não foi possível alocar o Produto selecionado',
          'top-right',
        );
      } else {
        this.setState({
          selectedAllocations: {},
          selectedIds: [],
        });

        addNotification(
          result.amountFail > 0 ? 'warning' : 'success',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          `${I18n.t('BEE2934', { 0: result.amountTotal, 1: result.amountSuccess, 2: result.amountFail })}${
            result.cableCutPlanCreated
              ? ` ${I18n.t('BEE4120' /* Plano de Corte gerado com sucesso! */)}`
              : ''
          }`,
          'top-right',
        );

        this.pendingProductAllocationDocumentsList();
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE3316' /* Produtos Pendentes para Alocação */),
          'Erro ao tentar alocar o Produto selecionado',
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      defaultPageSize, defaultSorted, productsList, documentsList, selectedDocument, selectedIds,
      showModalPendingAllocation, pages, totalDataLength, loading,
    } = this.state;

    return (
      <div>
        <Table
          breadcrumb={this.breadcrumb}
          wikiHelp={ROUTES.OUTBOUND_PENDING_ALLOCATION_PRODUCT_HELP}
          headerTitle={I18n.t('BEE3316' /* Produtos Pendentes para Alocação */)}
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          actionButtons={(
            <div className="ml-auto -my-5">
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-5"
                onClick={() => this.multipleSelection(true)}
              >
                {I18n.t('BEE1908' /* Marcar Todos */)}
              </button>
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-5"
                onClick={() => this.multipleSelection(false)}
              >
                {I18n.t('BEE1909' /* Desmarcar Todos */)}
              </button>
              <OneClickButton
                type="button"
                className="btn btn-140 btn-primary p-5 m-5"
                onClick={() => this.validChecked()}
              >
                {I18n.t('BEE2956' /* Alocação automática */)}
              </OneClickButton>

              {!Permissions.checkPermission(ROUTES.P_OUTBOUND_ORDER_MANAGE_FIELDS) && (
                <button
                  type="button"
                  className="btn btn-primary p-5"
                  onClick={() => this.showPageLayoutModal()}
                >
                  {I18n.t('BEE4439' /* Gerenciar Colunas */)}
                </button>
              )}
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.pendingProductAllocationDocumentsList,
            children: I18n.t('BEE462' /* Documentos */).toUpperCase(),
          }}
          downloadCSV
          filterable
          expander
          data={documentsList}
          columns={this.state.tableColumns}
          defaultPageSize={5}
          defaultSorted={this.defaultSortedOrders}
          manual
          pages={pages}
          loading={loading}
          totalDataLength={totalDataLength}
          onFetchData={(state) => {
            // A grid volta sozinha para a primeira pagina quando muda a
            // ordenacao ou o tamanho da pagina. O paginador do componente
            // guarda a pagina em estado proprio e precisa acompanhar, senao
            // mostra um numero diferente do que foi carregado.
            if (this.tableComponent && this.tableComponent.state.page !== state.page) {
              this.tableComponent.handlePageChange(state.page);
            }

            this.page = state.page;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.pendingProductAllocationDocumentsList();
          }}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
            return false;
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: async () => {
                  await this.setState({ selectedDocument: rowInfo.original });
                  await this.pendingProductAllocationsList();
                },
                style: {
                  background: selectedDocument && rowInfo.original
                    && rowInfo.original.outboundOrderId === selectedDocument.outboundOrderId
                    && rowInfo.original.productCode === selectedDocument.productCode ? 'silver' : 'white',
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
          ref={(r) => {
            this.tableComponent = r;
          }}
        />

        <Table
          panelHeaderProps={{
            children: I18n.t('BEE27' /* Produtos */).toUpperCase(),
          }}
          filterable
          expander
          downloadCSV
          data={productsList}
          columns={this.state.productTableColumns}
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {this.createPageLayoutModal()}
        {(showModalPendingAllocation
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.allocateBulkProduct(selectedIds)}
              onCancel={() => this.setState({ showModalPendingAllocation: false })}
            >
              {I18n.t('BEE2957', { 0: selectedIds.length } /* Foram selecionado(s) %{0} documento(s) */)}
            </SweetAlert>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  pendingProductAllocationDocumentsList:
    (tableParams) => dispatch(pendingProductAllocationDocumentsList(tableParams)),
  pendingProductAllocationDocumentIds:
    (tableParams) => dispatch(pendingProductAllocationDocumentIds(tableParams)),
  pendingProductAllocationsList: (outboundOrderId, productCode) => dispatch(pendingProductAllocationsList(
    outboundOrderId,
    productCode,
  )),
  allocateBulkProducts: (
    outboundProductIds,
  ) => dispatch(allocateBulkProducts(outboundProductIds)),
  getPageLayout: (pageLayout) => dispatch(getPageLayout(pageLayout)),
  updatePageLayout: (pageLayout) => dispatch(updatePageLayout(pageLayout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PendingAllocationProductList));
